var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE5\x9B\xBE\xE7\x89\x87"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000000970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.7971 1.20001C4.1041 1.20001 3.6001 1.76701 3.6001 2.39701V33.645C3.6001 34.338 4.1671 34.842 4.7971 34.842H31.7611C32.4541 34.842 32.9581 34.275 32.9581 33.645V8.57101L25.6501 1.20001H4.7971Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7971 1.20001C4.1041 1.20001 3.6001 1.76701 3.6001 2.39701V33.645C3.6001 34.338 4.1671 34.842 4.7971 34.842H31.7611C32.4541 34.842 32.9581 34.275 32.9581 33.645V8.57101L25.6501 1.20001H4.7971Z",
    fill: "url(#paint0_linear_1233_65)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    filter: "url(#filter0_d_1233_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5869 1.20001V7.31101C25.5869 8.00401 26.1539 8.50801 26.7839 8.50801H32.8949L25.5869 1.20001Z",
    fill: "#9BE7D4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.7348 13.107C12.7348 14.304 13.6798 15.249 14.8768 15.249C16.0738 15.249 17.0188 14.304 17.0188 13.107C17.0188 11.91 16.0738 10.965 14.8768 10.965C13.6798 11.028 12.7348 11.973 12.7348 13.107ZM22.3108 14.745L19.4758 20.163C19.3498 20.415 18.9718 20.541 18.7198 20.352L14.3728 17.328C14.1208 17.139 13.8058 17.202 13.6798 17.454L9.33277 24.321C9.08077 24.699 9.39577 25.203 9.83677 25.203H27.9178C28.3588 25.203 28.6738 24.699 28.4218 24.321L23.1298 14.745C23.0038 14.367 22.4998 14.367 22.3108 14.745Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1233_65",
    x: 24.3869,
    y: 0.600012,
    width: 9.70811,
    height: 9.70798,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1233_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1233_65",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1233_65",
    x1: 18.2791,
    y1: 1.20001,
    x2: 18.2791,
    y2: 34.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BD9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55C9AF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.9573f30028d8b6e950e0d9536218fcd5.svg";
export { ForwardRef as ReactComponent };